// Shared between the header dropdown, the results page and the unit tests.
// Kept in its own module so importing a number doesn't drag in MUI or the
// firebase client.

// Mirrors MIN_QUERY_LENGTH in api/src/routes/search.js. Below this the server
// answers with an empty result set rather than scanning, so the client doesn't
// bother asking.
export const MIN_QUERY_LENGTH = 2;

// How many rows each type shows before the "See all N" row takes over.
export const DROPDOWN_GROUP_LIMIT = 4;
export const RESULTS_PAGE_GROUP_LIMIT = 25;
